import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import classNames from 'classnames';

// Redux
import { connect } from 'react-redux';

// Comps
import FormSatCiec from './FormSatCiec';
import FormSatDownloadDetail from './FormSatDownloadDetail';
import FormSatRfc from './FormSatRfc';

// Icons
import AlertCircleIcon from 'mdi-react/AlertCircleIcon';

const Alert = (paidPue) => {
  const alertClassSat = classNames({
    'info-text': true,
    'sat-alert-active': paidPue === 1,
    'sat-alert-disabled': paidPue === 0,
  }); // END alertClassSat

  return (
    <div className={ alertClassSat }>
      <div className="icon-spei"><span><AlertCircleIcon color={ paidPue === 1 ? '#3F82FF' : '#7C7C7C' }/></span></div>
      <p className="help-text">Se creará un pago por cada factura <span>PUE (pago en una sola exhibición)</span> descargada. Para marcarla como &quot;Vencida&quot; deberás eliminar el pago</p>
    </div>
  )
}

const SatIntegrationDownloads = (props) => {
  const [page, setPage] = useState(1)
  const [enabled, setEnabled] = useState(0)
  const [connection, setConnection] = useState('notConnected')
  const [showPassword, setShowPassword] = useState(false)
  const [globalRfc, setGlobalRfc] = useState(null)

  useEffect(() => {
    setEnabled(get(props, 'sat_downloads.is_enabled'))
    if (get(props, 'sat_downloads.is_enabled') === 1) {
      setPage(3)
      setConnection('onLine')
    }
  }, [])

  const renderPage = () => {
    if (page === 1) {
      return(
        <FormSatRfc
          handleModal={ get(props, 'modal.toggle') }
          setPage={ setPage }
          setGlobalRfc={ setGlobalRfc }
        />
      )
    } else if (page === 2) {
      return(
        <FormSatCiec
          showPassword={ showPassword }
          setShowPassword={ setShowPassword }
          handleModal={ get(props, 'modal.toggle') }
          setPage={ setPage }
          globalRfc={ globalRfc }
          alert={ Alert }
        />
          )
    } else if (page === 3) {
      return(
        <FormSatDownloadDetail
          connection={ connection }
          showPassword={ showPassword }
          setShowPassword={ setShowPassword }
          enabled={ enabled }
          handleModal={ get(props, 'modal.toggle') }
          alert={ Alert }
        />
      )
    }
  }

  return (
    <React.Fragment>
      { renderPage() }
    </React.Fragment>
  )
}


export default connect(state => {
  return { 
    sat_downloads: get(state, 'integrations.sat_downloads')
  };

})(SatIntegrationDownloads);


// WEBPACK FOOTER //
// ./src/containers/account/components/satIntegration/SatIntegrationDownloads.js